<!-- Drawer -->
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040"
  [nzVisible]="ViewManPowerVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <h5 class="card-title">Movement Request Details</h5>
        <div class="card-body">

          <h5>REQUESTOR DETAILS</h5>
          <div class="row">

            <div class="col">
              <label><b>Request Reference</b></label>
              <p>{{ ApproveRequest?.reference }}</p>
            </div>
            <div class="col">
              <label><b>Requester Name</b></label>
              <p>{{ ApproveRequest?.requesterName }}</p>
            </div>
          </div>
          <div class="row">
          
          <div class="col">
            <label><b>Requester Function</b></label>
            <p>{{ ApproveRequest?.requesterFunction }}</p>
          </div>
          <div class="col">
            <label><b>Requester Unit</b></label>
            <p>{{ ApproveRequest?.requesterUnit }}</p>
          </div>
          </div>
          <div class="row">
          
            <div class="col">
              <label><b> Requester Designation</b></label>
              <p>{{ ApproveRequest?.requesterDesignation }}</p>
            </div>
            <div class="col">
              <label><b>Request Date</b></label>
              <p>{{ ApproveRequest?.requestDate | date: 'dd MMMM yyyy'}}</p>
            </div>
            

          
            </div>
        
          <hr>
          
          <h5>Current Employee Data</h5>
          <div class="row">

            <div class="col">
              <label><b>Employee Name</b></label>
              <p>{{ ApproveRequest?.employeeName }}</p>
            </div>
            <div class="col">
              <label><b>Date Assumed Current Role</b></label>
              <p>{{ ApproveRequest?.datAssumeCurrentRole | date: 'dd MMMM yyyy'}}</p>
            </div>

          </div>
          <div class="row">
          
          <div class="col">
            <label><b>Sap Number</b></label>
            <p>{{ ApproveRequest?.employeeSAPNumber }}</p>
          </div>
          <div class="col">
            <label><b>Employee Band</b></label>
            <p>{{ ApproveRequest?.employeeBand }}</p>
          </div>
          </div>

          <div class="row">
          
            <div class="col">
              <label><b>Designation</b></label>
              <p>{{ ApproveRequest?.employeeDesignation }}</p>
            </div>
            <div class="col">
              <label><b>Function</b></label>
              <p>{{ ApproveRequest?.employeeUnit }}</p>
            </div>
            </div>

            <div class="row">
          
              <div class="col">
                <label><b>Unit</b></label>
                <p>{{ ApproveRequest?.employeeUnit }}</p>
              </div>
              <div class="col">
                <label><b>N+1</b></label>
                <p>{{ ApproveRequest?.employeeNPlus1 }}</p>
              </div>
              </div>

              <div class="row">
          
                <div class="col">
                  <label><b>Location</b></label>
                  <p>{{ ApproveRequest?.employeeCurrentLocation }}</p>
                </div>
                <div class="col">
                  <label><b>Last Promotion Date</b></label>
                  <p>{{ ApproveRequest?.lastPromotionDate | date: 'dd MMMM yyyy'}}</p>
                </div>
                </div>

              
          <hr>
          <h5>Proposed Employee Data</h5>
          <div class="row">
            <div class="col">
              <label><b>Proposed Designation</b></label>
              <p>{{ ApproveRequest?.proposedDesignation }}</p>
            </div>

            <div class="col">
              <label><b>Proposed N+1</b></label>
              <p>{{ ApproveRequest?.proposedNPlus1 }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Proposed Function</b></label>
              <p>{{ ApproveRequest?.proposedFunction }}</p>
            </div>

            <div class="col">
              <label><b>Proposed Unit</b></label>
              <p>{{ ApproveRequest?.proposedUnit }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Effective Date</b></label>
              <p>{{ ApproveRequest?.effectiveDate | date: 'dd MMMM yyyy'}}</p>
            </div>

            <div class="col">
              <label><b>Proposed Band</b></label>
              <p>{{ ApproveRequest?.proposedBand }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Proposed Cost Center</b></label>
              <p>{{ ApproveRequest?.proposedCostCenter }}</p>
            </div>
            <div class="col">
              <label><b>Proposed Location</b></label>
              <p>{{ ApproveRequest?.proposedLocation }}</p>
            </div>

  
          </div>

          <hr>
          <h5>Role Details</h5>
          <div class="row">
            <div class="col">
              <label><b>Date Vacancy Occured</b></label>
              <p>{{ ApproveRequest?.dateVacancyOccured | date: 'dd MMMM yyyy'}}</p>
            </div>

            <div class="col">
              <label><b>Reason For Vacancy</b></label>
              <p>{{ ApproveRequest?.reasonForVacancy }}</p>
            </div>

          </div>
            
        <div class="row">
          <div class="col">
            <label><b>Justification For Movement</b></label>
            <p>{{ ApproveRequest?.justificationForVacancy }}</p>
          </div>

          <div class="col">
            <label><b>Type Of Movement</b></label>
            <p>{{ ApproveRequest?.typeOfMovement }}</p>
          </div>

        </div>

        <div class="row">
          <div class="col">
            <label><b>System Requirements For New Role </b></label>
            <p>{{ ApproveRequest?.systemRequirementForNewRole }}</p>
          </div>

        </div>

        <hr>
        <h5>Succession Plan And Transition</h5>
        <div class="row">
          <div class="col">
            <label><b>Job Performance/Performance Review</b></label>
          </div>
<hr>
<hr>
        </div>

        <div class="row">
          <div class="col">
            <label><b>Last Year</b></label>
            <p>{{ ApproveRequest?.performanceLastYear }}</p>
          </div>

          <div class="col">
            <label><b>2 Years</b></label>
            <p>{{ ApproveRequest?.twoYearsPerformance }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label><b>3 Years</b></label>
            <p>{{ ApproveRequest?.threeYearsPerformance }}</p>
          </div>

          <div class="col">
            <label><b>Last Talent Review Grid/Comments</b></label>
            <p>{{ ApproveRequest?.lastTalentReviewComment }}</p>
          </div>
        </div>
         

        

        <div class="row">
          <div class="col">
            <label><b>Succession Plan Ready</b></label>
            <p>{{ ApproveRequest?.successionPlanReady }}</p>
          </div>
          <div class="col">
            <label><b>Development Plan</b></label>
            <p>{{ ApproveRequest?.developmentPlan }}</p>
          </div>

         
        </div>

        <div class="row">
         
          <div class="col">
            <label><b>Identified Gaps</b></label>
            <p>{{ ApproveRequest?.identifiedGaps }}</p>
          </div>
        </div>
        </div>
        <br>
        <hr>
          <div class="row">
            <div class="col" *ngIf="canViewDocument">
              <div class="col pull right" >	
                <button (click)="getJD(ApproveRequest)">Download Document</button>
              </div>
              
            </div>

            <div class="col" *ngIf="canViewDocument">
              <div class="col pull right" >	
              <nz-space>
                 
                  <button *nzSpaceItem nz-button nzType="primary" (click)="showDocument(ApproveRequest)">View Document</button>
                </nz-space>
          </div>
        </div>
  
  
            <div class="col">
              <label><b>Comment</b></label>
              <input name="" id="" [(ngModel)]="Comment" class="form-control" placeholder="">
            </div>
          </div>

    
      </div>

    </div>
  </div>
   <!-- Approvals -->
   <div class="card-body" >
    <h5 class="card-title">Approvals</h5>
    <div class="table-responsive" >
      <table class="table table--striped table-hover">
        <thead>
          <tr>

            <th>
              Designation Name
            </th>

            <th>
              Approved By
            </th>
            <th>
              Date Approved
            </th>
            <th>
              Message
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of movementApprovals">
            <td>{{approval.designationName}}</td>
            <td>{{approval.approvedBy}}</td>
            <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
            <td>{{approval.message}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!movementApprovals?.length"
      style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
      <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
    </div>
    <!-- Approvals -->
  </div>
  <ng-template #footerTpl>
    <div style="float: right" class="d-print-none">
    
      <a   (click)="approveMovement()"> 
        <span style="margin-right: 8px;" class="btn btn-primary">
            Approve
        </span>
    </a> 
    
    <a   (click)="rejectMovement()"> 
      <span style="margin-right: 8px;"class="btn btn-danger">
          Reject
      </span>
  </a> 
      
      <button class="btn btn-light" style="margin-right: 8px;" (click)="close()">Close</button>
    </div>
  </ng-template>

</nz-drawer>
<!-- Drawer -->

<div class="content-wrapper">
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title"> Pending Approval</h4>
          <div class="table-responsive pt-3">
            <table class="table table--striped table-hover">
              <thead>
                <tr>
                  <th>
                    Reference
                  </th>
                  <th>
                    Request Date
                  </th>
                  <th>
                    Requester Name
                   </th>
                  <th>
                    Requester Designation
                  </th>

                  <th>
                    Created By    
                  </th>
                  <th>
                    Requester Function  
                  </th>
                </tr>
              </thead>
              <tbody>
                 <tr *ngFor="let datas of Movement" (click)="open(datas)" class="clickable">
                 
                  <td>{{datas.reference}}</td>

                  <td>{{datas.createdDate | date: 'dd MMMM yyyy'}}</td>

                  <td>{{datas.requesterName}}</td>

                  <td>{{datas.requesterDesignation}}</td> 
                  
                  <td>{{datas.createdBy}}</td> 

                  <td>{{datas.requesterUnit}}

                </tr>
              </tbody>
            </table>
          </div>

           <div *ngIf="!Movement?.length" style="text-align: center; padding: 18px;">
            <h4 style="color: rgba(128, 128, 128, 0.741); ">You have no request pending approval</h4>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>

